import styled from "styled-components";
import { breakpoints, colors } from "../../../variables";

export const StyledMainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.white};

  .ods-footer {
    width: 100%;
  }
  .ODSGlobalHeader:where([data-viewport=xx-large]) {
    height: 96px
  }
    .ODSGlobalHeader:where([data-viewport=x-large]) {
    height: 84px
  }
    .ODSGlobalHeader:where([data-viewport=large]) {
    height: 72px
  }
  .ODSGlobalHeader-FixedWrapper{
    border-bottom: 0.9px solid rgba(38, 38, 38, 1)
  }

.ODSFooterMenuItem:visited {
  color: var(--colours-basic-text, #000);
}
`;

export const StyledLoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height:100vh;
  background-color: var(--colours-basic-background);
   > div {
     height:100%;
   }
  
`;

export const StyledPromptPage = styled.div`
  width: 100%;
  padding-left: 75px;
  min-width: 1300px;
  height: 95vh;
  background: ${colors.white};
`;

export const StyledUpperSection = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 1rem;
  background-color: ${colors.white};

  .instruction {
    width: 70%;
  }
`;

export const StyledLabel = styled.div`
  font-size: 20px;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: -0.05px;
  display: flex;
  padding: 16px 0;
  align-items: center;
  color: ${colors.charcoalGray};
`;

export const StyledPlaygroundSection = styled.div`
  padding: 0 3rem 3rem;
`;

export const StyledFooterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 90%;
  align-items: center;

  .footer-main-heading {
   
    margin-bottom: 1rem;
    font-size: 12px;

    p {
      text-align: center;
      font-size: 35px;
      font-weight: 800;
      line-height: 28px;
      color:white;
    }
    span {
      font-size: 16px;
     line-height: 18px;
     color: rgb(153, 153, 153);
     display: inline-block;
     margin-top: 10px;
     margin-bottom: 10px;
     text-align: center;
     width: 100%;
 
    }
  }

  .social-icon {
    gap: 1rem;
    width: 100%;
    display: flex;
    margin-top: 1rem;
    text-align: center;
    justify-content: space-between;
  }
  .ODSFooterMenuItem>span  {
    font-color: white;
  }

  @media (max-width: ${breakpoints.tabletPortrait}px) {
    width: 100%;
  }
`;

export const StyledIconWrapper = styled.a`
  background-color: ${colors.magenta};
  border-radius: 29px;
  width: 46px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  > img {
    width: 46px;
    height: 46px;
  }
`;

export const LandingPageWrapper = styled.div`
  max-width: 1680px;
  width: 100%;
`;

export const StyledToastWrapper = styled.div`
  position: fixed;
  z-index: 999;
  top: 1%;
`;
